module.exports = __webpack_public_path__ + "static/img/college1.234206a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/college1.png
// module id = XwTK
// module chunks = 1